import { Button, Form, message } from 'antd';
import { Auth } from 'aws-amplify';
import React from 'react';
import { useHistory } from 'react-router';

import { IAuthProps } from '../../pages/Authentication';
import { redirectToLogin } from '../utils';
import styles from './Auth.module.css';
import { CardWithTitle, PasswordFormInput, error } from './utils';

const NewPassword: React.FC<IAuthProps> = ({
  form,
  authData,
  onStateChange,
  authState,
  onAuthEvent,
}) => {
  const { push } = useHistory();
  const [loading, setLoading] = React.useState<boolean>(false);

  const confirmNewPassword = React.useCallback(
    values => {
      setLoading(true);
      Auth.completeNewPassword(authData, values.password, {})
        .then(() => onStateChange('signIn', {}))
        .catch(err2 => {
          if (
            err2.message ===
            'User cannot be confirm. Current status is CONFIRMED'
          ) {
            redirectToLogin(push);
            onStateChange('signIn', {});
            message.success('Check your email');
          } else {
            error(err2, authState, onAuthEvent);
          }
        })
        .finally(() => setLoading(false));
    },
    [authData, onStateChange, onAuthEvent, authState, push]
  );

  return (
    <CardWithTitle title="Enter new password">
      <Form
        form={form}
        onFinish={confirmNewPassword}
        className="confirm-form"
        layout="vertical"
        hideRequiredMark
      >
        <PasswordFormInput newPassword />
        <Form.Item className={styles.confirmSignupConfirmFormItem}>
          <Button
            loading={loading}
            type="primary"
            size="large"
            shape="round"
            htmlType="submit"
            className={styles.signupCreateAccountButton}
            style={{ marginTop: '20pt' }}
          >
            Confirm
          </Button>
        </Form.Item>
      </Form>
    </CardWithTitle>
  );
};

export default NewPassword;
